import { PieChartItem } from "@snap-mobile/snap-ui/dist/types/utils";
import {
  SpendInviteType,
  useSpendInvitesFilteredQuery,
} from "graphql/generated";
import LabelValue from "pages/groups/collections/label-value";
import { useEffect, useState } from "react";
import Spinner from "shared-components/spinner";
import { SnapPieChart } from "suit";

function ParentSignups() {
  const [sent, setSent] = useState(0);
  const [active, setActive] = useState(0);
  const [expired, setExpired] = useState(0);
  const [unaccepted, setUnaccepted] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const [undelivered, setUndeliverable] = useState(0);
  const [pieChartOptions, setPieChartOptions] = useState<PieChartItem[]>([]);

  const { loading, data } = useSpendInvitesFilteredQuery({
    variables: {
      where: {
        type: [SpendInviteType.Guardian],
      },
    },
  });

  useEffect(() => {
    if (sent && active) {
      setPercentage(Math.trunc((active / sent) * 100));
    }
  }, [active, sent]);

  useEffect(() => {
    if (!loading && data?.spendInvitesFiltered) {
      const invites = data.spendInvitesFiltered.invites;
      const activeInvites =
        invites?.filter((i) => i?.status === "accepted").length ?? 0;
      const unacceptedInvites =
        invites?.filter((i) => new Date(Number(i?.expiresAt!)) > new Date() && i?.status !== "accepted").length ?? 0;
      const undeliveredInvites =
        invites?.filter((i) => !i?.isDeliverable).length ?? 0;
      const expiredInvites =
        invites?.filter(
          (i) =>
            new Date(Number(i?.expiresAt!)) < new Date() &&
            i?.status !== "accepted"
        ).length ?? 0;
      setActive(activeInvites);
      setUnaccepted(unacceptedInvites);
      setUndeliverable(undeliveredInvites);
      setExpired(expiredInvites);
      setSent(invites?.length ?? 0);

      setPieChartOptions([
        {
          category: "Active",
          value: activeInvites,
          color: "#F87171",
        },
        {
          category: "Unaccepted",
          value: unacceptedInvites,
          color: "#FBBF24",
        },
        {
          category: "Undelivered",
          value: undeliveredInvites,
          color: "#34D399",
        },
      ]);
    }
  }, [loading, data]);
  return (
    <div>
      <p className="text-lg font-semibold text-gray-500 lg:text-gray-800">
        Parent Signup
      </p>

      <div className="grid grid-cols-2">
        <div>
          <div className="w-[70%]">
            <div className="mt-4 front-medium lg:mt-6">
              <p className="text-5xl font-normal">{`${percentage}%`}</p>
              <p className="text-lg text-gray-500">Accepted</p>
            </div>
            <LabelValue
              label={"Sent"}
              value={sent.toString()}
              labelColor={"text-gray-500"}
              valueColor={""}
              className="mt-5"
            />
            <LabelValue
              label={"Active"}
              value={active.toString()}
              labelColor={"text-gray-500"}
              valueColor={""}
              className="mt-2"
            />
            <LabelValue
              label={"Unaccepted"}
              value={unaccepted.toString()}
              labelColor={"text-gray-500"}
              valueColor={""}
              className="mt-2"
            />
            <LabelValue
              label={"Undelivered"}
              value={undelivered.toString()}
              labelColor={"text-gray-500"}
              valueColor={""}
              className="mt-2"
            />
            <LabelValue
              label={"Expired"}
              value={expired.toString()}
              labelColor={"text-gray-500"}
              valueColor={""}
              className="mt-2"
            />
          </div>
        </div>
        <div className="hidden lg:inline-block self-center mt-2">
          {pieChartOptions.length === 0 && <Spinner />}
          <SnapPieChart
            height={200}
            innerRadius={60}
            options={pieChartOptions}
          />
        </div>
        <div className="lg:hidden self-center mt-2">
          {pieChartOptions.length === 0 && <Spinner />}
          <SnapPieChart
            height={60}
            innerRadius={50}
            options={pieChartOptions}
          />
        </div>
      </div>
    </div>
  );
}

export default ParentSignups;
